import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, initializeFirestore } from "firebase/firestore";
import config from './config';
import initializeEmulator from "./initializeEmulator";

const isDevelopmentEnvironment = process.env.NODE_ENV === "development";

const app = initializeApp(config);

export const auth = getAuth(!isDevelopmentEnvironment ? app : undefined);

let db;

if (isDevelopmentEnvironment) {
  db = getFirestore();
} else {
  db = initializeFirestore(app, {
    experimentalForceLongPolling: true
  });
}

export { db };


if (isDevelopmentEnvironment) {
  initializeEmulator({ auth, db })
} 


